import script from "./VacanciesResults.vue?vue&type=script&setup=true&lang=js"
export * from "./VacanciesResults.vue?vue&type=script&setup=true&lang=js"

import "./VacanciesResults.vue?vue&type=style&index=0&id=976feff4&lang=scss"

const __exports__ = script;

export default __exports__